module.exports = __webpack_public_path__ + "img/headRight4Logo.e491ab3d.png";